import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Flex } from '@mantine/core';
import type { EmbeddedPromptParentOut } from '@repo/api-codegen';
import { ChatHistoryItem } from './ChatHistoryItem';

interface ReorderableChatHistoryItemProps {
	chat: EmbeddedPromptParentOut;
	isActive: boolean;
	isPinned: boolean;
	onSelectChat: (chat: EmbeddedPromptParentOut) => void;
	onDeleteChat: (chat: EmbeddedPromptParentOut) => void;
	editingChatId: string | null;
	editingChatTitle: string;
	onStartEditingChatTitle: (chatId: string, currentTitle: string) => void;
	onStopEditingChatTitle: () => void;
	onSaveEditingChatTitle: (chatId: string) => void;
	onModifyEditingChatTitle: (title: string) => void;
	onTogglePin: (chatId: string) => void;
}

export function ReorderableChatHistoryItem({
	chat,
	isActive,
	isPinned,
	onSelectChat,
	onDeleteChat,
	editingChatId,
	editingChatTitle,
	onStartEditingChatTitle,
	onStopEditingChatTitle,
	onSaveEditingChatTitle,
	onModifyEditingChatTitle,
	onTogglePin,
}: ReorderableChatHistoryItemProps) {
	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		transition, // eslint-disable-line no-custom-animation/no-custom-animation
		isDragging,
		// eslint-disable-next-line no-custom-hooks-in-presentation-components/no-custom-hooks-in-presentation-components
	} = useSortable({
		id: chat.id,
		disabled: editingChatId !== null, // Disable dragging when any chat is being edited
	});

	const style = {
		transform: CSS.Transform.toString(transform),
		transition, // eslint-disable-line no-custom-animation/no-custom-animation
		opacity: isDragging ? 0.5 : 1,
		zIndex: isDragging ? 1000 : 'auto',
	};

	return (
		<Flex ref={setNodeRef} style={style} {...attributes} {...listeners}>
			<ChatHistoryItem
				chat={chat}
				isActive={isActive}
				isPinned={isPinned}
				onSelectChat={onSelectChat}
				onDeleteChat={onDeleteChat}
				editingChatId={editingChatId}
				editingChatTitle={editingChatTitle}
				onStartEditingChatTitle={onStartEditingChatTitle}
				onStopEditingChatTitle={onStopEditingChatTitle}
				onSaveEditingChatTitle={onSaveEditingChatTitle}
				onModifyEditingChatTitle={onModifyEditingChatTitle}
				onTogglePin={onTogglePin}
			/>
		</Flex>
	);
}
